import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, isRef as _isRef, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18c534dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading px20" }, "カテゴリ一覧", -1))
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("完了")
const _hoisted_5 = {
  key: 1,
  class: "flex"
}
const _hoisted_6 = { class: "px20" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "カテゴリ一覧", -1))
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_10 = { class: "px20" }
const _hoisted_11 = { class: "question-header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Q&A一覧", -1))
const _hoisted_13 = { class: "add-action text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.46 39.46",
  width: "31px",
  height: "31px",
  class: "position"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "レイヤー_2",
    "data-name": "レイヤー 2"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "レイヤー_1-2",
      "data-name": "レイヤー 1"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        class: "cls-1",
        cx: "19.73",
        cy: "19.73",
        r: "19.73"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        class: "cls-2",
        d: "M29.28,21.43h-7.8V29.2H18V21.43H10.17V18H18V10.26h3.5V18h7.8Z"
      })
    ])
  ])
], -1))
const _hoisted_15 = { class: "action" }

import { ref, onMounted, onUnmounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router'
// import { ElMessage } from "element-plus"
// import ActionCable from "actioncable";
// import axios from "axios";
import QuestionList from "@/components/question/QuestionList.vue";
import CategoryList from "@/components/common/categories/CategoryList.vue"
import QuestionForm from "@/components/question/QuestionForm.vue";
import QuestionCategoriesEdit from "@/components/common/categories/CategoriesEdit.vue";
import QuestionDetail from "@/components/question/QuestionDetail.vue";
// import HeaderKnowledge from "@/components/HeaderKnowledge.vue";
import { QuestionDetailLogic } from "@/logic/question/QuestionDetailLogic";
import { QuestionListLogic } from "@/logic/question/QuestionListLogic";
import { QuestionFavoriteLogic } from "@/logic/question/QuestionFavoriteLogic";
import { QuestionCategoryLogic } from "@/logic/question/QuestionCategoryLogic";
import { QusitionState } from "@/state/QusitionState";
import { ElMessage } from "element-plus"



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute()
const {
  addQuestion,
  deleteQuestion,
  loadQuestion,
  resetQuestion,
  updateQuestion,
  moveQuestionCategory,
  detailCommentLoading,
  detailIineLoading,
  detailQuestionLoading,
  detailAddQuestionLoading,
  iine,
  cancelIine,
  sendComment,
  updateComment,
  deleteComment,
  user_views,
  loadViewUsers
} = QuestionDetailLogic();
const {
  loadQuestions,
  loadQuestionsWithQuestionCategory,
  listLoading,
  noMore,
  keyword,
  filterFavorite,
  filterNewer,
  sort,
  sortItems,
  listErrors
} = QuestionListLogic();
const {
  loadQuestionCategories,
  addQuestionCategory,
  updateQuestionCategory,
  deleteQuestionCategory,
  sortQuestionCategory,
  questionCategoryErrors,
  questionCategoryLoading


} = QuestionCategoryLogic();
const {
  favorite,
  cancelFavorite,

} = QuestionFavoriteLogic();
const question = computed(() => QusitionState.state.question);
const questions = computed(() => QusitionState.state.questions);
const questionCategories = computed(() => QusitionState.state.questionCategories);
const questionCategoryId = computed(() => QusitionState.state.questionCategoryId);
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);
watch(listErrors, () => {
  if (listErrors.value == "") {
    return;
  }
  ElMessage({
    showClose: true,
    message: listErrors.value,
    type: 'error'
  });
  listErrors.value = "";
})
watch(questionCategoryErrors, () => {
  if (questionCategoryErrors.value == "") {
    return;
  }
  ElMessage({
    showClose: true,
    message: questionCategoryErrors.value,
    type: 'error'
  });
  questionCategoryErrors.value = "";
})

// let questionChannel = null;
let canSearch = ref(false);
let formVisible = ref(false);
// let formQuestionCategoryVisible = ref(false);
let formEditQuestionCategoryVisible = ref(false);
// let editingQuestionCategoryName = ref("");
// let formQuestionCategoryId = ref(0);
let questionCategoryEditMode = ref(false)
let filterText = ref("")
// const formQuestion = reactive({
// body: "",
// answer: ""
// });
const switchCategryEditMode = (val) => {
  questionCategoryEditMode.value = val;
  // TODO 編集完了時には再読込する
  loadQuestionsWithQuestionCategory(0);
}

const search = () => {
  if (canSearch.value == false) {
    return;
  }
  // 初期リセット
  // listLoading.value = true;
  loadQuestions(true, true);
  canSearch.value = false;
  // noMore.value = false;
};
const searchAction = (word) => {
  keyword.value = word;
  loadQuestions(true);
  canSearch.value = false;
};

const loadCategories = () => {
  loadQuestionCategories();
};
const updateQuestionCategoryAndClose = (target_id, name) => {
  updateQuestionCategory(target_id, name);
  formEditQuestionCategoryVisible.value = false;

}
watch(() => route.params.project_id, () => {
  if (route.params.project_id) {
    QusitionState.setProjectId(route.params.project_id);
    loadQuestions(true)
    loadCategories();
  }
})

onUnmounted(() => {
  resetQuestion();
});
onMounted(() => {
  QusitionState.setProjectId(route.params.project_id);

  loadCategories();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(questionCategoryEditMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createVNode(_component_el_card, { class: "category-list edit-category" }, {
            default: _withCtx(() => [
              _hoisted_2,
              (_unref(questionCategoryEditMode))
                ? (_openBlock(), _createBlock(QuestionCategoriesEdit, {
                    key: 0,
                    class: "colum-flex-body",
                    onUpdateCategory: updateQuestionCategoryAndClose,
                    onAddCategory: _unref(addQuestionCategory),
                    onDeleteCategory: _unref(deleteQuestionCategory),
                    onSortCategory: _unref(sortQuestionCategory),
                    categories: _unref(questionCategories)
                  }, null, 8, ["onAddCategory", "onDeleteCategory", "onSortCategory", "categories"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  style: {"width":"80%"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (switchCategryEditMode(false)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 512), [
            [_directive_loading, _unref(questionCategoryLoading)]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_el_card, { class: "category-list" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_el_input, {
                  modelValue: _unref(filterText),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filterText) ? (filterText).value = $event : filterText = $event)),
                  placeholder: "キーワードを入力",
                  class: "el-input-round el-input-height"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(CategoryList, {
                class: "colum-flex-body mt10",
                filterText: _unref(filterText),
                categories: _unref(questionCategories),
                onListClick: _unref(loadQuestionsWithQuestionCategory)
              }, null, 8, ["filterText", "categories", "onListClick"]),
              (_unref(managerFlg))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      style: {"width":"90%"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (switchCategryEditMode(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512), [
            [_directive_loading, _unref(questionCategoryLoading)]
          ]),
          _withDirectives(_createVNode(_component_el_card, { class: "question-list" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    (_unref(managerFlg))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "unstyled-button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(formVisible) //@ts-ignore
 ? formVisible.value = !_unref(formVisible) : formVisible = !_unref(formVisible)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_el_input, {
                  class: "search el-input-round el-input-height",
                  modelValue: _unref(keyword),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(keyword) ? (keyword).value = $event : null)),
                  onKeyup: _withKeys(search, ["enter"]),
                  onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_isRef(canSearch) //@ts-ignore
 ? canSearch.value = true : canSearch = true)),
                  clearable: "",
                  onClear: _cache[6] || (_cache[6] = ($event: any) => (searchAction(''))),
                  placeholder: "キーワードを入力"
                }, null, 8, ["modelValue", "onKeyup"]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: _unref(filterFavorite),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(filterFavorite) ? (filterFavorite).value = $event : null)),
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_unref(loadQuestions)(true))),
                    label: "お気に入り"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_checkbox, {
                    modelValue: _unref(filterNewer),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(filterNewer) ? (filterNewer).value = $event : null)),
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_unref(loadQuestions)(true))),
                    label: "新着のみ"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_component_el_select, {
                  modelValue: _unref(sort),
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(sort) ? (sort).value = $event : null)),
                  size: "small",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_unref(loadQuestions)(true)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortItems), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(QuestionList, {
                class: "colum-flex-body",
                questions: _unref(questions),
                listLoading: _unref(listLoading),
                noMore: _unref(noMore),
                questionCategoryId: _unref(questionCategoryId),
                question_id: _unref(question) ? _unref(question).id : null,
                onLoad: _unref(loadQuestions),
                onShowDetail: _unref(loadQuestion),
                onIine: _unref(iine),
                onCancelIine: _unref(cancelIine)
              }, null, 8, ["questions", "listLoading", "noMore", "questionCategoryId", "question_id", "onLoad", "onShowDetail", "onIine", "onCancelIine"])
            ]),
            _: 1
          }, 512), [
            [_directive_loading, _unref(listLoading)]
          ]),
          _createVNode(_component_el_card, { class: "main" }, {
            default: _withCtx(() => [
              _createVNode(QuestionDetail, {
                question: _unref(question),
                detailLoading: _unref(detailQuestionLoading),
                iineLoading: _unref(detailIineLoading),
                commentLoading: _unref(detailCommentLoading),
                questionCategories: _unref(questionCategories),
                detailLink: true,
                user_views: _unref(user_views),
                onUpdateQuestion: _unref(updateQuestion),
                onDeleteQuestion: _unref(deleteQuestion),
                onIine: _unref(iine),
                onCancelIine: _unref(cancelIine),
                onFavorite: _unref(favorite),
                onCancelFavorite: _unref(cancelFavorite),
                onSendComment: _unref(sendComment),
                onUpdateComment: _unref(updateComment),
                onMoveQuestionCategory: _unref(moveQuestionCategory),
                onDeleteComment: _unref(deleteComment),
                onLoadViewUsers: _unref(loadViewUsers)
              }, null, 8, ["question", "detailLoading", "iineLoading", "commentLoading", "questionCategories", "user_views", "onUpdateQuestion", "onDeleteQuestion", "onIine", "onCancelIine", "onFavorite", "onCancelFavorite", "onSendComment", "onUpdateComment", "onMoveQuestionCategory", "onDeleteComment", "onLoadViewUsers"])
            ]),
            _: 1
          })
        ])),
    _createVNode(QuestionForm, {
      modelValue: _unref(formVisible),
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(formVisible) ? (formVisible).value = $event : formVisible = $event)),
      loading: _unref(detailAddQuestionLoading),
      disableForm: _unref(detailAddQuestionLoading),
      categoryList: _unref(questionCategories),
      defaultCategoryId: _unref(QusitionState).state.questionCategoryId,
      onAddQuestion: _unref(addQuestion)
    }, null, 8, ["modelValue", "loading", "disableForm", "categoryList", "defaultCategoryId", "onAddQuestion"])
  ], 64))
}
}

})